/**
 * Route Meta Configuration
 * Contains meta tag information for each route in the application
 */

const routeMetaConfig = {
  "/": {
    title: "Free Online Bingo Caller | Let's Play Bingo",
    description: "Free online bingo caller, no ads. Audible caller, 1,000+ patterns, bingo card generator, and offline play. Perfect for home, church, school, or Zoom games.",
    keywords: "bingo caller, free bingo caller, online bingo caller, bingo, bingo game, play bingo online, virtual bingo, audible bingo caller, 90 ball bingo, bingo card generator, free bingo",
    ogTitle: "Free Online Bingo Caller | Let's Play Bingo",
    ogDescription: "Free bingo caller with no ads. Audible calling, 1,000+ patterns, offline support, and a free bingo card generator.",
  },
  "/generator": {
    title: "Free Bingo Card Generator | Let's Play Bingo",
    description: "Generate custom bingo cards to print for your games! Create up to 500 randomized cards with customizable patterns, colors, and layouts. Perfect for home, church, school, or bar bingo games.",
    keywords: "bingo card generator, print bingo cards, custom bingo cards, bingo card maker, free bingo cards, printable bingo cards, bingo card template",
    ogTitle: "Free Bingo Card Generator | Let's Play Bingo",
    ogDescription: "Generate and print custom bingo cards with patterns. Create up to 500 unique cards at once - completely free!",
  },
  "/patterns": {
    title: "Bingo Patterns Library | Let's Play Bingo",
    description: "Browse our collection of 1,000+ bingo patterns including classics like Four Corners, Blackout, and specialty patterns. Use these patterns in your bingo games or create your own custom patterns.",
    keywords: "bingo patterns, bingo game patterns, four corners bingo, blackout bingo, custom bingo patterns, bingo pattern library, bingo winning patterns",
    ogTitle: "Bingo Patterns Library | Let's Play Bingo",
    ogDescription: "Explore 1,000+ bingo patterns from classic to creative. Select, customize, or submit your own patterns!",
  },
  "/play": {
    title: "Play Along Bingo Card | Let's Play Bingo",
    description: "Play along with your bingo game! Use this page to generate your own bingo card and play along while someone else calls the numbers. Perfect for virtual bingo nights over Zoom.",
    keywords: "play bingo online, virtual bingo card, online bingo card, play along bingo, zoom bingo, virtual bingo night, free bingo card",
    ogTitle: "Play Along | Let's Play Bingo",
    ogDescription: "Generate your own bingo card and play along with the caller. Perfect for virtual game nights!",
  },
  "/help": {
    title: "Help & Instructions | Let's Play Bingo",
    description: "Learn how to use Let's Play Bingo! Comprehensive instructions for game setup, pattern selection, audio settings, offline mode, and troubleshooting common issues.",
    keywords: "bingo caller help, bingo game instructions, how to play bingo, bingo caller tutorial, bingo app help, bingo game setup",
    ogTitle: "Help & Instructions | Let's Play Bingo",
    ogDescription: "Complete guide to using Let's Play Bingo including game setup, settings, and troubleshooting.",
  },
  "/faq": {
    title: "Frequently Asked Questions | Let's Play Bingo",
    description: "Common questions about Let's Play Bingo including pricing, offline mode, audible caller, card generation, and supported devices. Get answers to your bingo questions here!",
    keywords: "bingo FAQ, bingo questions, bingo caller questions, free bingo app, bingo app help, is let's play bingo free",
    ogTitle: "Frequently Asked Questions | Let's Play Bingo",
    ogDescription: "Get answers to common questions about using Let's Play Bingo for your games.",
  },
  "/about": {
    title: "About Let's Play Bingo",
    description: "Learn about the story behind Let's Play Bingo, created in loving memory of Grandma Josephine. A passion project to bring families together through bingo.",
    keywords: "about let's play bingo, bingo app creator, bingo app story, free bingo app developer",
    ogTitle: "About Let's Play Bingo | Our Story",
    ogDescription: "The story of Let's Play Bingo - a passion project created to bring families together through bingo.",
  },
  "/contact": {
    title: "Contact Us | Let's Play Bingo",
    description: "Get in touch with Let's Play Bingo! Report bugs, suggest features, ask questions, or share how you're using the app. We'd love to hear from you!",
    keywords: "contact bingo app, report bingo bug, bingo feature request, bingo app support, contact developer",
    ogTitle: "Contact Us | Let's Play Bingo",
    ogDescription: "Have questions or feedback? Get in touch with the Let's Play Bingo team!",
  },
  "/submitpattern": {
    title: "Submit a Bingo Pattern | Let's Play Bingo",
    description: "Share your creative bingo patterns with the community! Submit your custom pattern designs to be featured in Let's Play Bingo's pattern library.",
    keywords: "submit bingo pattern, custom bingo pattern, bingo pattern creator, share bingo pattern, bingo pattern submission",
    ogTitle: "Submit Your Bingo Pattern | Let's Play Bingo",
    ogDescription: "Created a unique bingo pattern? Share it with the Let's Play Bingo community!",
  },
  "/releases": {
    title: "Release Notes & Updates | Let's Play Bingo",
    description: "View the latest updates, new features, and bug fixes for Let's Play Bingo. See what's new in each version and track the app's development history.",
    keywords: "bingo app updates, let's play bingo updates, bingo app changelog, bingo app version history, bingo app release notes",
    ogTitle: "Release Notes & Updates | Let's Play Bingo",
    ogDescription: "Stay up to date with the latest features and improvements to Let's Play Bingo.",
  },
  "/reset": {
    title: "Let's Play Bingo! | Reset Settings",
    description: "Reset all Let's Play Bingo settings and clear cached data. This will restore the app to its default state.",
    keywords: "reset bingo app, clear bingo cache, restore default settings, bingo app reset",
    ogTitle: "Reset Settings | Let's Play Bingo",
    ogDescription: "Reset your Let's Play Bingo settings to default.",
  },
  "/privacy": {
    title: "Let's Play Bingo! | Privacy Policy",
    description: "Read Let's Play Bingo's privacy policy. Learn how we handle your data and protect your privacy while using our free bingo calling application.",
    keywords: "bingo app privacy, privacy policy, data protection, bingo app security",
    ogTitle: "Privacy Policy | Let's Play Bingo",
    ogDescription: "Our commitment to protecting your privacy while using Let's Play Bingo.",
  },
  "/terms": {
    title: "Let's Play Bingo! | Terms of Service",
    description: "Read the terms of service for Let's Play Bingo. Understand your rights and responsibilities when using our free bingo calling application.",
    keywords: "bingo app terms, terms of service, bingo app legal, user agreement",
    ogTitle: "Terms of Service | Let's Play Bingo",
    ogDescription: "Terms of service for using Let's Play Bingo.",
  },
  "/layouts": {
    title: "Layouts Gallery | Let's Play Bingo",
    description: "Preview and apply bingo caller layouts. Choose from Classic, Easy View, Simple, Stacked, Vertical, 90 Ball, Legacy Edition, and more.",
    keywords: "bingo caller layout, bingo caller display, bingo caller view, bingo caller screen layout",
    ogTitle: "Layouts Gallery | Let's Play Bingo",
    ogDescription: "Preview all available bingo caller layouts and apply one with a single click.",
  },
  "/guide": {
    title: "Bingo Caller Settings Guide | Let's Play Bingo",
    description: "Complete guide to every setting in Let's Play Bingo. Learn how to configure the audible caller, game modes, layouts, patterns, Wild Bingo, hot ball, and more.",
    keywords: "bingo caller settings, bingo app guide, bingo caller options, how to set up bingo caller, bingo game settings, bingo caller tutorial",
    ogTitle: "Settings Guide | Let's Play Bingo",
    ogDescription: "Complete guide to configuring every setting in Let's Play Bingo — caller options, game modes, layouts, patterns, and more.",
  },
  "/donate": {
    title: "Support Let's Play Bingo | Donate",
    description: "Let's Play Bingo is free and ad-free thanks to the generosity of its players. If you enjoy the app, consider making a donation to help cover hosting and development costs.",
    keywords: "donate bingo app, support let's play bingo, bingo app donation",
    ogTitle: "Support Let's Play Bingo | Donate",
    ogDescription: "Help keep Let's Play Bingo free and ad-free. Donate via Buy Me a Cup of Tea, PayPal, or Venmo.",
  },
  "/thanks": {
    title: "Let's Play Bingo! | Thank You",
    description: "Thank you for contacting Let's Play Bingo! We'll get back to you as soon as possible.",
    keywords: "thank you, contact confirmation, message received",
    ogTitle: "Thank You | Let's Play Bingo",
    ogDescription: "Thank you for reaching out to Let's Play Bingo!",
  },
  "/404": {
    title: "Let's Play Bingo! | Page Not Found",
    description: "The page you're looking for doesn't exist. Return to Let's Play Bingo to start calling your bingo games!",
    keywords: "404, page not found, error",
    ogTitle: "Page Not Found | Let's Play Bingo",
    ogDescription: "This page doesn't exist. Visit Let's Play Bingo to start your game!",
  },
};

/**
 * Gets meta tag configuration for a given route
 * @param {string} path - Route path
 * @returns {object} Meta tag configuration object
 */
export const getRouteMetaConfig = (path) => {
  return routeMetaConfig[path] || routeMetaConfig["/"];
};

export default routeMetaConfig;
